import React from 'react';

// Neon animated SIM360° wordmark used in headers
const Sim360Neon = ({ size = 'md', className = '' }) => {
  const sizeClasses =
    size === 'lg'
      ? 'text-lg lg:text-xl'
      : size === 'sm'
      ? 'text-[11px] lg:text-xs'
      : 'text-sm lg:text-base';

  return (
    <span
      className={`relative inline-flex items-center gap-1 font-black tracking-[0.22em] ${sizeClasses} ${className}`}
      aria-label="SIM360°"
      data-testid="sim360-neon"
    >
      <span
        aria-hidden
        className="relative"
        style={{
          background: 'linear-gradient(90deg, #00f4ff 0%, #12b7ff 50%, #7c3aed 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          filter: 'drop-shadow(0 0 6px rgba(0,244,255,0.55)) drop-shadow(0 0 14px rgba(18,183,255,0.35))',
          textShadow: '0 0 6px rgba(0,244,255,0.35)'
        }}
      >
        SIM360
      </span>
      <span
        aria-hidden
        className="text-[#00f4ff]"
        style={{
          filter: 'drop-shadow(0 0 6px rgba(0,244,255,0.6))'
        }}
      >
        °
      </span>
      {/* Pulsing dot */}
      <span
        aria-hidden
        className="ml-1 inline-block w-1.5 h-1.5 rounded-full animate-pulse"
        style={{
          backgroundColor: '#00f4ff',
          boxShadow: '0 0 8px rgba(0,244,255,0.9), 0 0 16px rgba(0,244,255,0.55)'
        }}
      />
    </span>
  );
};

export default Sim360Neon;
